// extracted by mini-css-extract-plugin
module.exports = {"BatchActionsBar":"BatchActionsBar_BatchActionsBar__3MC0y","Label":"BatchActionsBar_Label__b1BcJ"};